import "./GalleryHome.module.css";
import GalleryHeader from "@/reusable_sections/Header";
import Monolith from "./sections/Monolith";
import FeaturedEdition from "./sections/FeaturedEdition";
import Collection from "./sections/Collection";
import Categories from "./sections/Categories";
import Manifesto from "./sections/Manifesto";
import Trust from "./sections/Trust";
import Inquiry from "./sections/Inquiry";
import Archive from "@/reusable_sections/Footer";
export default function GalleryHomePage() {
  return <div>
      <GalleryHeader />
      <Monolith />
      <FeaturedEdition />
      <Collection />
      <Categories />
      <Manifesto />
      <Trust />
      <Inquiry />
      <Archive />
    </div>;
}